
export enum DocumentType
{
    CertificationRecord = 1,
    PublicHealthRecord = 2,
    ClinicalRecord = 3
}

